<!-- TodaySummary.vue -->
<template>
	<div>
		<div class="row">
			<div v-if="showTitle" class="col-md-12 mb-1 d-flex align-items-center justify-content-center">
				<div>
					<h5>DO Outstanding {{ tabLabel }}</h5>
				</div>
				<div class="ml-auto">
					<el-popover trigger="click" size="small" ref="dropdown" v-model="dropdownVisible" popper-class="dropdown-filter">
						<el-button slot="reference" type="primary" plain size="small">
							<i class="fa fa-filter"></i> &nbsp; Filter
						</el-button>
						<div>
							<div class="ps-3 pe-3 pt-1 pb-1">
								<h5><i class="fa fa-filter"></i> &nbsp; Filter</h5>
							</div>
							<el-divider class="m-0"></el-divider>
							<div class="dropdown-filter-form">
								<el-form label-position="top" label-width="100px">
									<div class="row">

										<div class="col-md-6">	
											<el-form-item label="Station">
												<el-select v-model="stationid" clearable filterable placeholder="Select Station" size="small" style="width:100%;">
													<el-option v-for="item7 in spbu.list" :key="item7.StationId" :label="item7.StationName" :value="item7.StationId">
													</el-option>
												</el-select>
											</el-form-item>
										</div>

										<div class="col-md-6">	
											<el-form-item label="SAP DO Date:">
												<div class="block" style="max-width: 250px;">								
													<el-date-picker
													v-model="dateRange"
													type="daterange"
													align="right"
													size="small" 
													unlink-panels
													range-separator="-"
													start-placeholder="Start date"
													end-placeholder="End date"
													format="yyyy-MM-dd"
													value-format="yyyy-MM-dd"
													:picker-options="pickerOptions">
													</el-date-picker>
												</div>
											</el-form-item>
										</div>
						
										<div class="col-md-6" v-if="is2024OrBelow">
											<el-form-item label="Area">
												<el-radio-group v-model="area" size="small" name="area">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

										<div class="col-md-6" v-if="is2025OrAbove">
											<el-form-item label="Region">
												<el-radio-group v-model="region" size="small" name="region">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.region" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

										<div class="col-md-6">
											<el-form-item label="Owner">
												<el-radio-group v-model="owner" size="small" name="owner">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.owner" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>
									
										<div class="col-md-6">
											<el-form-item label="Type">
												<el-radio-group v-model="stationtype" size="small" name="type">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.types" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>

										<div class="col-md-6">
											<el-form-item label="Status">
												<el-radio-group v-model="status" size="small" name="status">
													<el-radio-button :label="item5.value" v-for="(item5, index5) in options.status" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
												</el-radio-group>
											</el-form-item>
										</div>
									</div>

								</el-form>
							</div>
							<el-divider class="m-0"></el-divider>
							<div class="py-2 px-4">
								<div class="row">
									<div class="col-md-12 d-flex align-items-center">
										<div class="ml-auto">
											<el-button type="danger" size="medium" @click="closeDropdownForm" style="min-width:100px;"><i class="fa fa-close"></i> &nbsp; Close</el-button>
											<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="min-width:100px;"><i class="fa fa-check"></i> &nbsp; Apply Filter</el-button>
										</div>										
									</div>
								</div>
							</div>
						</div>
					</el-popover>

					<el-button class="ms-2" type="success" plain size="small" @click="exportExcel()" v-if="reportdata?.data?.length">
						<i class="fa fa-file-excel"></i> &nbsp; Export
					</el-button>

					<vue-excel-xlsx 
						v-show="false"
						ref="excelExport"
						:data="dataXLSX(reportdata)"
						:columns="columnXLSX(reportdata)"
						:file-name="'DO Outstanding ' + tabLabel"
						:file-type="'xlsx'"
						:sheet-name="'sheet1'"
						>
						<i class="far fa-file-excel"></i>
					</vue-excel-xlsx>
				</div>
			</div>

			<div class="col-md-12" v-if="false">
				<div>
					<el-form label-position="top" label-width="100px">
						<div class="row">
							<div class="col-md-5">	
								<el-form-item label="Station">
									<el-select v-model="stationid" clearable filterable placeholder="Select Station" size="small" style="width:100%;">
										<el-option v-for="item7 in spbu.list" :key="item7.StationId" :label="item7.StationName" :value="item7.StationId">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="col-md-3">	
								<el-form-item label="SAP DO Date:">
									<div class="block">								
										<el-date-picker
										v-model="dateRange"
										type="daterange"
										align="right"
										size="small" 
										unlink-panels
										range-separator="-"
										start-placeholder="Start date"
										end-placeholder="End date"
										format="yyyy-MM-dd"
										value-format="yyyy-MM-dd"
										:picker-options="pickerOptions">
										</el-date-picker>
									</div>
								</el-form-item>
							</div>
						</div>

						<div class="row">
							<div class="col-md-5" >
									<el-form-item label="Area">
										<el-radio-group v-model="area" size="small" name="area">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-5">
									<el-form-item label="Owner">
										<el-radio-group v-model="owner" size="small" name="owner">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.owner" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
						</div>

						<div class="row">
							<div class="col-md-5">
								<el-form-item label="Type">
									<el-radio-group v-model="stationtype" size="small" name="type">
										<el-radio-button :label="item5.value" v-for="(item5, index5) in options.types" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
									</el-radio-group>
								</el-form-item>
							</div>

							<div class="col-md-5">
								<el-form-item label="Status">
									<el-radio-group v-model="status" size="small" name="status">
										<el-radio-button :label="item5.value" v-for="(item5, index5) in options.status" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
									</el-radio-group>
								</el-form-item>
							</div>
						</div>

						<div class="row">
							<div class="col-md-5 mt-0">	
								<el-form-item label=" ">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Filter</el-button>
								</el-form-item>
							</div>
						</div>
					</el-form>
				</div>
			</div>

			<div class="row p-0 m-0 mt-2">
				<div class="col-md-12">
					<ReportResultTable :reportname="'DOOutstandingReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/> 
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import Finance from '@/components/page/Finance.js'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, Config, AxiosWithJar, Penanggalan } from '@/utility.js'
import ReportResultTable from '@/views/pages/ReportResultTable2Custom.vue'
//import Loader from '@/components/loader/Loader2.vue'

export default {
	extends: Finance,
	props: ['tabIndex','tabName', 'tabLabel', 'showTitle'],
	components: { 
        ReportResultTable,
	},
	data(){
		return {
            urlRequestParams: '',
            reportdata: { data: [] },  // Ensure it's an object with a 'data' property
            stationid: '',
            plant: '',
            area: '',
            region: '',
            stationtype: '',
            owner: '',
            status: '',
            spbu: {
                list: [],
            },
			options: {
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				region:[
					{ value: "", name: "ALL" }, 
					//{ value: "region", name: "BY REGION", field: "RegionPertareId" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
					{ value: "6", name: "6" }, 
					{ value: "7", name: "7" }, 
				],
				owner:[
					{ value: "", name: "ALL" }, 
					{ value: "COCO", name: "COCO" }, 
					{ value: "KSO", name: "KSO" }, 
					{ value: "TAC", name: "TAC" }, 
				],
				types:[
					{ value: '', name: 'ALL' },
					{ value: 'SPBU', name: 'SPBU' },
					//{ value: 'SPBG', name: 'SPBG' },
					{ value: 'PERTASHOP', name: 'PERTASHOP' },
					//{ value: 'SPBU-T', name: 'SPBU-T' },
					//{ value: 'SHELTER', name: 'SHELTER' },
					{ value: 'MODULAR', name: 'MODULAR' },
				],
				status:[
					{ value: "", name: "ALL" }, 
					{ value: "Delivered", name: "DELIVERED" }, 
					{ value: "Outstanding", name: "OUTSTANDING" }, 
					{ value: "Deleted", name: "DELETED" }, 
				],
			},
            loading: {
                table: false,
                isSuccess: false,
            },
            date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
            dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().bulanSekarang, this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin], 
            pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

			is2024OrBelow: false,
			is2025OrAbove: true,
			dropdownVisible: false,
			filteredData2024AndBelow: [],
			filteredData2025AndAbove: [],

        }
    },
    mounted() {
        this.$emit('childrenRoute');
        this.loadStationList();
        //this.getData();
    },
	watch: {
		dateRange(newValue, oldValue) {
			let yearCategory = this.getYearCategory(newValue);
			// && is2024OrBelow
			if(yearCategory == 1) {
				//year 2025 or above
				this.is2025OrAbove = true;
				this.is2024OrBelow = false;

				this.region = '';
				this.area = '';
			} else if(yearCategory == 2) {
				//year 2024 or below
				this.is2024OrBelow = true;
				this.is2025OrAbove = false;

				this.region = '';
				this.area = '';
			} else {
				//year mixed
				this.is2024OrBelow = true;
				this.is2025OrAbove = true;

				this.region = '';
				this.area = '';
			} 
			
			//console.log('area: ' + this.area);
			//console.log('region: ' + this.region);
		},
	},
    methods: { 
        async loadStationList(type='') {
			this.urlRequestParams = Config().apiURL
            this.urlRequestParams += "/fuel2/station?"  + (type ? "&type=" + type : "") + (this.plant ? "&plant=" + this.plant : "") + (this.stationid ? "&station=" + this.stationid : "");
			await AxiosWithJar().get(this.urlRequestParams).then(result=>{
				if(result.data.data.length){
					this.spbu.list = result.data.data;
				}
			})
		},

        getData() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/dooutstanding/reportdetail?'
            this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0] : '')
			this.urlRequestParams+='&date-range-end='+ (this.dateRange && this.dateRange[1] ? this.dateRange[1] : '')
            this.urlRequestParams+='&stationid='+this.stationid

            this.urlRequestParams+='&area='+this.area
            this.urlRequestParams+='&region='+this.region
            this.urlRequestParams+='&type='+this.stationtype
            this.urlRequestParams+='&owner='+this.owner
            this.urlRequestParams+='&status='+this.status

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.reportdata = response.data;  // Update the data property of reportdata
				})
				.catch(error => {
					console.log(error)
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

        applyFilter() {
			this.dropdownVisible = false; 
            this.getData()
        },

		exportExcel() {
			this.$refs["excelExport"].exportExcel();
			//console.log('export excel');
		},

		closeDropdownForm() {
			this.dropdownVisible = false; 
		},
    }
}
</script>
